import React from 'react';
import PropTypes from 'prop-types';

const Title = ({ title }) => (
  <div className="auth__title">
    {title}
  </div>
);

Title.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Title;


// WEBPACK FOOTER //
// ./src/components/Authentication/components/Title.js